export enum CampaignType {
    marketUpdate = 'Rental Marketplace Update'
}
